import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import React from "react";

const CssTextField = withStyles({
  root: {
    width: 240,
    "& label.Mui-focused": {
      color: "#f9aa33"
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#f9aa33"
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#f9aa33"
      },
      "&:hover fieldset": {
        borderColor: "#f9aa33"
      },
      "&.Mui-focused fieldset": {
        borderColor: "#f9aa33"
      }
    }
  }
})(TextField);

export default function CustomizedInput(props) {
  return (
    <div>
      {props.type === undefined ? (
        <CssTextField id="custom-css-standard-input" label={props.label} onChange={text => props.onChangeListener(text)} />
      ) : (
        <CssTextField label={props.label} type="password" onChange={text => props.onChangeListener(text)} style={{ marginTop: 5 }} />
      )}
    </div>
  );
}
